import React from "react"

import Logo from "../../../static/images/Hommey_Brandmark_Black_RGB.png"

import Account from "../../../static/icons/account.svg"
import Cart from "../../../static/icons/cart.svg"
import Search from "../../../static/icons/search.svg"
// import Account from "../../../static/icons/Account.svg"
// import Cart from "../../../static/icons/Cart.svg"
// import Search from "../../../static/icons/Search.svg"
import Arrowdown from "../../../static/icons/arrowdown.svg"
import Add from "../../../static/icons/Add.svg"
import BackButton from "../../../static/icons/BackButton.svg"
import BacktoTop from "../../../static/icons/BacktoTop.svg"
import Menu from "../../../static/icons/menu.svg"
// import Menu from "../../../static/icons/Menu.svg"
import Cancel from "../../../static/icons/Cancel.svg"
import Cross from "../../../static/icons/Cross.svg"
import CrossRounded from "../../../static/icons/CrossRounded.svg"
import Home from "../../../static/icons/Home.svg"
import Plus from "../../../static/icons/Plus.svg"
import Minus from "../../../static/icons/Minus.svg"
import Square from "../../../static/icons/Square.svg"
import Lumbar from "../../../static/icons/Lumbar.svg"
import Round from "../../../static/icons/Round.svg"
import Rectangle from "../../../static/icons/Lumbar.svg"
import Circle from "../../../static/icons/Round.svg"
import ArrowDesktop from "../../../static/icons/ArrowDesktop.svg"
import ArrowMobile from "../../../static/icons/ArrowMobile.svg"
import Tick from "../../../static/icons/Tick.svg"
import Chat from "../../../static/icons/Chat.svg"
import StartOver from "../../../static/icons/StartOver.svg"
import Show from "../../../static/icons/Show.svg"
import Hide from "../../../static/icons/Hide.svg"
import TickedBoxActive from "../../../static/icons/TickedBoxActive.svg"
import TickedBoxInactive from "../../../static/icons/TickedBoxInactive.svg"
import ArrowDropdown from "../../../static/icons/ArrowDropdown.svg"
import Afterpay from "../../../static/icons/afterpay.svg"
import ApplePay from "../../../static/icons/applepay.svg"
import Amex from "../../../static/icons/amex.svg"
import GooglePay from "../../../static/icons/googlepay.svg"
import Visa from "../../../static/icons/visa.svg"
import MasterCard from "../../../static/icons/mastercard.svg"
import ShopPay from "../../../static/icons/shoppay.svg"
import PayPal from "../../../static/icons/paypal.svg"
import Close from "../../../static/icons/close.svg"
import Prev from "../../../static/icons/Prev.svg"
import Next from "../../../static/icons/Next.svg"
import linkarrow from "../../../static/icons/linkarrow.svg"
import newnext from "../../../static/icons/new-next-arrow.svg"
import newprev from "../../../static/icons/new-prev-arrow.svg"
import Unchecked from "../../../static/icons/Unchecked.svg"
import Checked from "../../../static/icons/Checked.svg"
import DisabledCheckbox from "../../../static/icons/DisabledCheckbox.svg"
import Insta from "../../../static/icons/Insta.svg"
import FB from "../../../static/icons/FB.svg"
import RightArrow from "../../../static/icons/rightArr.svg"

export const withIcon =
  Component =>
  ({ componentName = "Icon", size = "20", name, title, ...props }: any) => {
    const icons = {
      logo: Logo,
      tick: Tick,
      account: Account,
      cart: Cart,
      search: Search,
      backbutton: BackButton,
      backtoTop: BacktoTop,
      menu: Menu,
      cross: Cross,
      crossRounded: CrossRounded,
      home: Home,
      plus: Plus,
      minus: Minus,
      square: Square,
      lumbar: Lumbar,
      round: Round,
      vintageArrow: ArrowDesktop,
      add: Add,
      arrowMobile: ArrowMobile,
      chat: Chat,
      startOver: StartOver,
      show: Show,
      hide: Hide,
      tickedBoxActive: TickedBoxActive,
      tickedBoxInactive: TickedBoxInactive,
      arrowDropdown: ArrowDropdown,
      afterpay: Afterpay,
      applepay: ApplePay,
      amex: Amex,
      googlepay: GooglePay,
      visa: Visa,
      mastercard: MasterCard,
      shoppay: ShopPay,
      paypal: PayPal,
      close: Close,
      prev: Prev,
      next: Next,
      cancel: Cancel,
      linkarrow: linkarrow,
      arrowdown: Arrowdown,
      newnext: newnext,
      newprev: newprev,
      unchecked: Unchecked,
      checked: Checked,
      disabledCheckbox: DisabledCheckbox,
      insta: Insta,
      fb: FB,
      rightArrow: RightArrow,
      Rectangle: Rectangle,
      Circle: Circle,
    }

    const icon = icons[name]

    Component.displayName = componentName
    return <Component {...props} icon={icon} size={size} title={title || name} />
  }
